const VERBOSITY_ALIASES = {
    '0': 'normal',
    '1': 'normal',
    '2': 'debugging',
    '3': 'debugging',
    warn: 'normal',
    warning: 'normal',
    info: 'normal',
    debug: 'debugging',
    trace: 'debugging',
    verbose: 'debugging',
};

const METHOD_THRESHOLDS = {
    error: 0,
    warn: 1,
    info: 2,
    log: 3,
    debug: 3,
};

const VERBOSITY_THRESHOLDS = {
    normal: 2,
    debugging: 3,
};

const ORIGINAL_CONSOLE = {
    error: console.error.bind(console),
    warn: console.warn.bind(console),
    info: console.info.bind(console),
    log: console.log.bind(console),
    debug: console.debug.bind(console),
};

let consoleConfigured = false;

export function getFrontendVerbosity() {
    const raw = (process.env.REACT_APP_VERBOSITY || '').trim().toLowerCase();
    if (!raw) {
        return process.env.NODE_ENV === 'production' ? 'normal' : 'debugging';
    }
    if (['normal', 'debugging'].includes(raw)) {
        return raw;
    }
    return VERBOSITY_ALIASES[raw] || 'normal';
}

export function isFrontendDebugEnabled() {
    return getFrontendVerbosity() === 'debugging';
}

export function installConsoleVerbosity() {
    if (consoleConfigured) {
        return;
    }

    const activeVerbosity = getFrontendVerbosity();
    const activeThreshold = VERBOSITY_THRESHOLDS[activeVerbosity] ?? VERBOSITY_THRESHOLDS.normal;

    Object.entries(ORIGINAL_CONSOLE).forEach(([method, original]) => {
        const methodThreshold = METHOD_THRESHOLDS[method];
        if (methodThreshold <= activeThreshold) {
            console[method] = original;
            return;
        }
        console[method] = () => {};
    });

    consoleConfigured = true;
}
